"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reactIntl = require("react-intl");

var _react = _interopRequireWildcard(require("react"));

var _copyToClipboard = _interopRequireDefault(require("copy-to-clipboard"));

var _icon = _interopRequireDefault(require("../icon"));

var _tooltip = _interopRequireDefault(require("../tooltip"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _messages = _interopRequireDefault(require("./messages"));

var _style = _interopRequireDefault(require("./style.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cx = _bind["default"].bind(_style["default"]);

var InputCopy = /*#__PURE__*/function (_PureComponent) {
  _inherits(InputCopy, _PureComponent);

  var _super = _createSuper(InputCopy);

  function InputCopy() {
    var _this;

    _classCallCheck(this, InputCopy);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isTooltipShown: false
    });

    _defineProperty(_assertThisInitialized(_this), "handleCopy", function () {
      var _this$props = _this.props,
          input = _this$props.input,
          onCopy = _this$props.onCopy;
      (0, _copyToClipboard["default"])(input.value);

      if (typeof onCopy === 'function') {
        onCopy();
      }

      _this.setState({
        isTooltipShown: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSelectOnClick", function (event) {
      event.currentTarget.select();
    });

    _defineProperty(_assertThisInitialized(_this), "handleCloseTooltipWithTimeout", function () {
      setTimeout(function () {
        _this.setState({
          isTooltipShown: false
        });
      }, 2000);
    });

    return _this;
  }

  _createClass(InputCopy, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          intl = _this$props2.intl,
          input = _this$props2.input,
          type = _this$props2.type,
          size = _this$props2.size,
          appearance = _this$props2.appearance,
          inline = _this$props2.inline,
          onClick = _this$props2.onClick,
          containerRef = _this$props2.containerRef,
          selectOnClick = _this$props2.selectOnClick,
          style = _this$props2.style,
          rest = _objectWithoutProperties(_this$props2, ["intl", "input", "type", "size", "appearance", "inline", "onClick", "containerRef", "selectOnClick", "style"]);

      var isTooltipShown = this.state.isTooltipShown;
      return /*#__PURE__*/_jsx("div", {
        style: _objectSpread({
          display: inline ? 'inline-block' : 'block'
        }, style)
      }, void 0, /*#__PURE__*/_react["default"].createElement("div", {
        ref: containerRef,
        style: {
          position: 'relative',
          width: '100%',
          display: inline ? 'inline-block' : 'block'
        }
      }, /*#__PURE__*/_react["default"].createElement('input', _objectSpread(_objectSpread(_objectSpread({}, rest), input), {}, {
        onChange: function onChange() {
          return void 0;
        },
        readOnly: true,
        onClick: selectOnClick ? this.handleSelectOnClick : onClick,
        className: cx('xsui-input', 'xsui-input-copy', "xsui-input--size-".concat(size), 'xsui-input--offset-right', selectOnClick && 'xsui-input-copy--selectable', appearance && "xsui-input--appearance-".concat(appearance)),
        value: input.value === null || input.value === void 0 ? '' : String(input.value),
        type: type,
        children: null,
        'data-id': input.name,
        'data-value': input.value
      })), /*#__PURE__*/_jsx("div", {
        className: cx('xsui-input__extra')
      }, void 0, /*#__PURE__*/_jsx(_tooltip["default"], {
        label: intl.formatMessage(_messages["default"].copied),
        open: isTooltipShown,
        onShown: this.handleCloseTooltipWithTimeout,
        style: {
          height: 24
        }
      }, void 0, /*#__PURE__*/_jsx(_icon["default"], {
        name: "copy",
        hoverable: true,
        onClick: this.handleCopy
      })))));
    }
  }]);

  return InputCopy;
}(_react.PureComponent);

_defineProperty(InputCopy, "defaultProps", {
  type: 'text',
  size: 'md',
  appearance: 'primary',
  inline: false,
  selectOnClick: false
});

var _default = (0, _reactIntl.injectIntl)(InputCopy);

exports["default"] = _default;